import { AppView, PLATFORM_OVERLAY_EXTRASMALL } from "@gaming/srvg-classes-core";
import { ChunkIndicatorView } from "../ChunkIndicatorView";
import { ChunkAreaView } from "../ChunkAreaView";
import { VideoAreaView } from "../VideoAreaView";
import { LivescoreWidget } from "../../../widgets/View/VfWidget/LivescoreWidget";
import { TimelineWidget } from "../../../widgets/View/VfWidget/TimelineWidget";

/**
 * Main view class for the VFC cup view.
 */
export class CupView extends AppView {
    chunkIndicatorView:ChunkIndicatorView;
    livescoreWidget: LivescoreWidget;
    videoAreaView: VideoAreaView;
    chunkAreaView:ChunkAreaView;

    constructor(options) {
        options = options || {};
        options.name = options.name || 'cupView';
        options.selector = '#' + options.name;
        super(options);
        this.isExpanded = true;

        this.chunkIndicatorView = this.addSubView(new ChunkIndicatorView({}));

        this.livescoreWidget = null;
        if (srvg.widgets.enabled){
            // Livescore widget if it is enabled in configuration file
            if (srvg.widgets.widgets['livescore'].enabled){
                this.livescoreWidget = this.addSubView(new LivescoreWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: '#LivescoreWidget',
                    // how many columns should be shown in livescore widget
                    numOfColumns: 4,
                    platform: 'desktop-small'
                }));
            }
        }

        this.videoAreaView = this.addSubView( new VideoAreaView( {} ) );

        if (srvg.widgets.enabled){
            // Timeline widget if it is enabled in configuration file
            if (srvg.widgets.widgets['timeline'].enabled){
                this.videoAreaView.addSubView(new TimelineWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: '#eventtimelineWidget',
                    platform: PLATFORM_OVERLAY_EXTRASMALL,
                    // show country flags in timeline widget
                    showFlags: true,
                    showAbbreviations: false
                }));
            }
        }

        this.chunkAreaView = this.addSubView(new ChunkAreaView({chunkPickerView: true}));
    }

    // hide all elements that would still be shown after other elements are already enabled
    handleTimeoutEvent( event, provider ) {
        $('#eventtimelineWidget').css('display','none');
    }
}
